import { useEffect } from 'react';
import type { RefObject } from 'react';
import { useLocation } from 'react-router';

type ScrollTriggerDependency = string | number | boolean | object | null | undefined;

function scrollToElement(element: HTMLElement | null) {
  if (!element) {
    return;
  }
  const elementViewportTop = element.getBoundingClientRect().top;
  if (elementViewportTop > 0) {
    return;
  }

  const body = document.querySelector('body');
  if (!body) {
    return;
  }
  const paddingTop = parseFloat(window.getComputedStyle(body).paddingTop);
  const scrollTop = Math.max(body.scrollTop, document.documentElement.scrollTop, window.pageYOffset);
  const top = elementViewportTop + scrollTop - paddingTop;
  body.scrollTo(0, top);
}

export default function useScroll(
  ref: RefObject<HTMLElement | null> | null = null,
  when: ScrollTriggerDependency = null,
) {
  const { pathname } = useLocation();

  return useEffect(() => {
    const element =
      ref?.current || document.querySelector('#main-content') || document.querySelector('#carbon-calculator');

    scrollToElement(element instanceof HTMLElement ? element : null);
  }, [ref, pathname, when]);
}
